import { useEffect, useMemo, useState } from "preact/hooks";
import { Trans } from "@lingui/react/macro";
import { OutTotoEntry } from "../../../services/totocalcio/types";
import { TotoEvent, TotoTicket, useTotocalcioApi, useTotocalcioTicket, useTotocalcioTournament, useTotocalcioTournamentsList } from "../../../services/totocalcio/totocalcio-service";

import { MyJackpotsView, SingleTournament, TotoTicketSidebar, TotoTournamentsList } from "../desktop-components/toto-jackpot";
import { Tab, TournamentFilter, TournamentPreviewWidget } from "../desktop-templates/toto-jackpot";
import FullSite from "./full-site";
import { JackpotViewType, TABS, TotoPageProps } from "../desktop-pages/toto-jackpot";
import { route } from "preact-router";
import User from "../../../services/user";


export function TotoPage({ tab, id }: TotoPageProps) {
    const api = useTotocalcioApi();

    const currentTabId = tab || 'open';
    const mode = useMemo(() => {
        if (id) return { type: JackpotViewType.SINGLE, tournamentId: parseInt(id) };
        if (tab === 'my-bets') return { type: JackpotViewType.MY_JACKPOTS };
        return { type: JackpotViewType.GENERAL };
    }, [id, tab]);

    const tournaments = useTotocalcioTournamentsList(api, currentTabId == 'my-bets' ? 'open' : currentTabId);

    const currentTournament = useMemo(() => {
        if (mode.type !== JackpotViewType.SINGLE) return null;
        return tournaments.tournamentsList.find(t => t.tournament.id === mode.tournamentId);
    }, [tournaments.tournamentsList, mode]);

    const details = useTotocalcioTournament(api, currentTournament?.tournament);

    const ticketApi = useMemo(() => (
        details.tournamentInfo && currentTournament
            ? new TotoTicket(api, currentTournament.tournament, currentTournament.prizes, details.tournamentInfo)
            : null)
        , [api, currentTournament, details.tournamentInfo]
    );

    const ticketState = useTotocalcioTicket(ticketApi);
    const [isTicketOpen, setIsTicketOpen] = useState(false);

    const handleOpenTournament = (tournament: OutTotoEntry) => {
        setIsTicketOpen(false);
        route(`/jackpots/${currentTabId}/${tournament.tournament.id}`);
    };

    const handleBackClick = () => {
        setIsTicketOpen(false);
        route(`/jackpots/${currentTabId === 'my-bets' ? 'open' : currentTabId}`);
    };

    const handleChangeTab = (tabId: string) => {
        setIsTicketOpen(false);
        route(`/jackpots/${tabId}`);
    };

    const ALL_TABS = [
        ...TABS,
        User.isLogged() ? { id: 'my-bets', name: () => <Trans>My History</Trans> } : null
    ].filter(x => !!x);

    return (
        <FullSite>
            <div class="flex flex-col bg-harif-950 text-white font-sans overflow-hidden border-t border-t-harif-900 relative">
                <div class="relative">
                    <main class={`flex-1 bg-harif-950 ${mode.type === JackpotViewType.SINGLE ? 'pb-20' : ''}`}>
                        {/* HEADER / FILTRI */}
                        <TournamentFilter>
                            {ALL_TABS.map(t => (
                                <Tab
                                    active={currentTabId === t.id}
                                    onClick={() => handleChangeTab(t.id)}
                                >
                                    {t.name()}
                                </Tab>
                            ))}
                        </TournamentFilter>

                        {/* BODY DINAMICO */}
                        {mode.type === JackpotViewType.GENERAL && !tournaments.isLoading && (
                            <TotoTournamentsList
                                handleOpenTournament={handleOpenTournament}
                                tournaments={tournaments}
                            />
                        )}

                        {mode.type === JackpotViewType.SINGLE && currentTournament && (
                            <SingleTournament
                                tournament={currentTournament}
                                handleBackClick={handleBackClick}
                                details={details}
                                ticketApi={ticketApi}
                            />
                        )}

                        {mode.type === JackpotViewType.MY_JACKPOTS && (
                            <MyJackpotsView api={api} />
                        )}
                    </main>

                    {/* Overlay modale ticket - stile Harif */}
                    <aside class={`absolute inset-0 z-50 bg-harif-950 p-2 flex flex-col overflow-y-auto transition-transform duration-300 ${isTicketOpen ? 'translate-y-0' : 'translate-y-full'}`}>
                        {/* Bottone chiudi */}
                        <div
                            class="flex items-center px-4 py-3 mb-2 bg-harifzinc-800 border border-harifzinc-700 text-amber-500 justify-center relative cursor-pointer"
                            onClick={() => setIsTicketOpen(false)}
                        >
                            <span class="text-sm font-bold tracking-wide uppercase"><Trans>Close Betslip</Trans></span>
                        </div>

                        {ticketApi && <TotoTicketSidebar ticketApi={ticketApi} isLogged={User.isLogged()} />}
                    </aside>
                </div>

                {/* Bottone flottante apri ticket */}
                {!isTicketOpen && mode.type === JackpotViewType.SINGLE && ticketApi && ticketState.odds.value.length > 0 && (
                    <div class="fixed bottom-0 left-0 right-0 p-3 bg-harif-900 border-t border-t-harif-950 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.5)] z-50">
                        <button
                            class="w-full bg-amber-500 hover:brightness-110 py-3 text-sm text-black font-black uppercase tracking-widest"
                            onClick={() => setIsTicketOpen(true)}
                        >
                            <Trans>Open Betslip</Trans> ({ticketState.odds.value.length})
                        </button>
                    </div>
                )}
            </div>
        </FullSite>
    );
}